import axios from 'axios'

import store from '@/store'

export const baseURL = process.env.VUE_APP_API_ORIGIN || ''

axios.defaults.baseURL = baseURL
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common['Access-Control-Allow-Methods'] =
  'GET, PUT, POST, DELETE, OPTIONS'
axios.defaults.timeout = 1000 * 120 // milliseconds

export const setAccessToken = () => {
  const jwtToken = localStorage.getItem('jwtToken')
  if (!jwtToken || jwtToken.length === 0) {
    store.dispatch('user/logout')
    return
  }
  axios.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`
}
